import FundamenteiMetadata from "components/seo/FundamenteiMetadata";
import parse from "date-fns/parse";
import { useIntl } from "react-intl";
import MailTo from "../components/errors/MailTo";
import PolicyPage from "../components/policies/PolicyPage";

export default function PaymentAndRefunds() {
  const intl = useIntl();
  if (!intl.locale.startsWith("pt")) {
    return (
      <>
        <FundamenteiMetadata title="Payments & Refunds | Fundamentei" />

        <PolicyPage title="Payments & Refunds" lastUpdatedAt={parse("2019-10-08", "yyyy-MM-dd", new Date())}>
          <div className="prose prose-gray max-w-none p-4 lg:prose-lg">
            <h3>Payment Methods</h3>

            <p>
              Currently, we only accept Visa and Mastercard credit cards. We do not accept transfers, debit cards, etc.
            </p>

            <h3>Recurring Charges</h3>

            <p>
              We will automatically charge your card monthly or annually for the subscription period. If the charge is
              not processed, you will be notified via email.
            </p>

            <h3>Unrenewed Subscriptions</h3>

            <p>
              If we are unable to charge your card after your
              {`subscription's`} due date, it will be automatically canceled. You will still be able to use the site for
              free.
            </p>

            <h3>No Refunds</h3>

            <p>
              You can cancel your subscription at any time; however, since the charge is monthly, we will not refund the
              subscription amount back to your card.
            </p>

            <h3>Cancellation</h3>

            <p>
              To cancel your subscription, simply go to <strong>{`Account > Manage Subscription > Cancel`}</strong>.
              Simple as that.
            </p>

            <div>
              <h3>Disputes</h3>

              <p>
                If you have questions about any charge on your card, please send an email to{" "}
                <MailTo address="contato@fundamentei.com" /> so we can assist you and get things resolved more quickly.
              </p>
            </div>

            <h3>Support</h3>

            <p>
              If you encounter any problems, it is our priority and mission to resolve it as quickly as possible!
              Contact us at <MailTo address="contato@fundamentei.com" />.
            </p>
          </div>
        </PolicyPage>
      </>
    );
  }
  return (
    <>
      <FundamenteiMetadata title="Pagamentos & reembolsos | Fundamentei" />

      <PolicyPage title="Pagamentos & reembolsos" lastUpdatedAt={parse("2019-10-08", "yyyy-MM-dd", new Date())}>
        <div className="prose prose-gray max-w-none p-4 lg:prose-lg">
          <h3>Métodos de pagamento</h3>

          <p>
            Atualmente aceitamos apenas cartões de crédito Visa, Mastercard e boleto. Não aceitamos transferências,
            cartões de débito, etc.
          </p>

          <h3>Cobranças recorrentes</h3>

          <p>
            Nós iremos cobrar mensalmente de maneira automática no seu cartão ou lhe enviar o boleto referente ao
            período da assinatura. Caso a cobrança não seja efetuada, você será notificado pelo seu email.
          </p>

          <h3>Assinaturas não renovadas</h3>

          <p>
            Em caso de não conseguirmos cobrar no seu cartão—ou o boleto ser compensado, em um prazo de até 7 dias após
            o vencimento da sua assinatura, a mesma será cancelada automáticamente. Você ainda poderá utilizar o site de
            maneira gratuita.
          </p>

          <h3>Período de testes</h3>

          <p>
            Como o oferecemos assinatura mensal no formato <em>cancele-quando-quiser</em>, não trabalhamos com período
            de testes. Você pode assinar por apenas um mês se preferir.
          </p>

          <h3>Sem reembolsos</h3>

          <p>
            Você poderá cancelar sua assinatura quando quiser, porém, sendo que a cobrança é mensal, não faremos nenhum
            estorno do valor da assinatura de volta para o seu cartão.
          </p>

          <h3>Cancelamento</h3>

          <p>
            Para cancelar sua assinatura, basta você ir em {`Conta > "Gerenciar Assinatura > Cancelar"`}. Tão simples
            quanto isso.
          </p>

          <div>
            <h3>Disputas / Contestação</h3>

            <p>
              Se você está em dúvida sobre alguma cobrança no seu cartão, por favor, envie um email em{" "}
              <MailTo address="contato@fundamentei.com" /> para que possamos ajudar você com o mínimo de fricção
              possível.
            </p>
          </div>

          <h3>Suporte</h3>

          <p>
            Caso você tenha algum problema, é nossa prioridade e missão resolvê-lo o mais rápido possível! Entre em
            contato através do email <MailTo address="contato@fundamentei.com" />.
          </p>
        </div>
      </PolicyPage>
    </>
  );
}
